<template>
  <div class="tutorial-step-video">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item style="margin: 0;">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addVideoNode"
          >{{ $t('training_tutorial_step_video.tian_jia_shi_pin') }}</el-button>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right;margin: 0;">
          <el-input
            :placeholder="$t('training_tutorial_step_video.qsrspmc')"
            v-model="formSearch.trainingName"
            clearable
            @keyup.enter.native="getVideoList()"
            style="width: 280px;"
          >
            <template slot="append">
              <div @click="getVideoList()">
                <i class="icon icon-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-box">
      <div class="video-release-list" v-if="unPublished.length>0">
        <p class="titel">{{$t('training_tutorial_step_video.wei_fa_bu')}}</p>
        <ul>
          <li class="card-line" v-for="(item,index) in unPublished" :key="index">
            <div class="thumbnail" @click="viewVideo(item)">
              <!-- <i class="icon icon-ceshibaogao current"></i> -->
              <!-- <div class="video" v-if="item.trainingVedio">
                <video :src="item.trainingVedio">{{$t('您的浏览器不支持video播放','com_your_browser_does_not_support_video_playback')}}</video>
                <i class="icon icon-zanting"></i>
              </div>
              <img v-else :src="item.trainingIcon" alt /> -->
              <img :src="item.trainingIcon" alt />
            </div>
            <div class="info">
              <p>{{$t('training_tutorial_step_video.shi_pin_ming_cheng')}}</p>
              <span class="value">{{item.trainingName}}</span>
            </div>
            <div class="inner">
              <div class="param">
                <div class="name status">
                  <p>{{$t('Common.com_status')}}</p>
                  <span class="value">{{cloud_common_publish[item.trainingState]}}</span>
                </div>
                <div class="name charper">
                  <p>{{$t('training_tutorial_step_video.zhang_jie_shu')}}</p>
                  <span class="value">{{item.nodeNum}}</span>
                </div>
                <div class="name">
                  <p>{{$t('training_tutorial_step_video.shun_xu')}}</p>
                  <span class="value">{{item.showOrder}}</span>
                </div>
                <div class="name">
                  <p>{{$t('training_tutorial_step_video.chuang_jian_ren')}}</p>
                  <span class="value">{{item.creator}}</span>
                </div>
                <div class="name">
                  <p>{{$t('training_tutorial_step_video.chuang_jian_shi_jian')}}</p>
                  <span class="value">{{momentAmPm($momentLocal(item.gmtCreate))}}</span>
                </div>
              </div>
            </div>
            <div class="more">
              <div class="edit" @click="editVideo(item.trainingId)">{{$t('Common.com_edit')}}</div>
              <div class="delete" @click="deleteVideoNode(item)">{{$t('Common.com_delete')}}</div>
              <div class="details" @click="publishState(item)">
                {{$t('training_tutorial_step_video.fa_bu')}}
                <!-- <i class="icon icon-you"></i> -->
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="video-releaseno-list" v-if="releaseList.length>0">
        <p class="titel">{{$t('training_tutorial_step_video.yi_fa_bu')}}</p>
        <ul>
          <li class="card-line" v-for="(item,index) in releaseList" :key="index">

            <div class="thumbnail" @click="viewVideo(item)">
              <!-- <div class="video" v-if="item.trainingVedio">
                <video :src="item.trainingVedio">{{$t('您的浏览器不支持video播放','com_your_browser_does_not_support_video_playback')}}</video>
                <i class="icon icon-zanting"></i>
              </div>
              <img v-else :src="item.trainingIcon" alt /> -->
              <img :src="item.trainingIcon" alt />
            </div>
            <div class="info">
              <p>{{$t('training_tutorial_step_video.shi_pin_ming_cheng')}}</p>
              <span class="value">{{item.trainingName}}</span>
            </div>
            <div class="inner">
              <div class="param">
                <div class="name status">
                  <p>{{$t('Common.com_status')}}</p>
                  <span class="value">{{cloud_common_publish[item.trainingState]}}</span>
                </div>
                <div class="name charper">
                  <p>{{$t('training_tutorial_step_video.zhang_jie_shu')}}</p>
                  <span class="value">{{item.nodeNum}}</span>
                </div>
                <div class="name">
                  <p>{{$t('training_tutorial_step_video.shun_xu')}}</p>
                  <span class="value">{{item.showOrder}}</span>
                </div>
                <div class="name">
                  <p>{{$t('training_tutorial_step_video.chuang_jian_ren')}}</p>
                  <span class="value">{{item.creator}}</span>
                </div>
                <div class="name">
                  <p>{{$t('training_tutorial_step_video.chuang_jian_shi_jian')}}</p>
                  <span class="value">{{momentAmPm($momentLocal(item.gmtCreate))}}</span>
                </div>
              </div>
            </div>
            <div class="more">
              <!-- <div class="edit" @click="editVideo(item.trainingId)">{{$t('编辑','com_edit')}}</div>
              <div class="delete" @click="deleteVideoNode(item)">{{$t('删除','com_delete')}}</div> -->
              <div class="details" @click="publishStateNo(item)">
                {{$t('training_tutorial_step_video.che_xiao_fa_bu')}}
                <!-- <i class="icon icon-you"></i> -->
              </div>
            </div>
          </li>
        </ul>
      </div>
      <p class="no-data" v-if="unPublished.length===0 && releaseList.length===0">{{$t('Common.com_no_data')}}</p>
    </div>
    <div class="footer">
      <el-button @click="onCancel">
        {{
        $t('Common.com_cancel')
        }}
      </el-button>
      <el-button type="primary" @click="onBack">
        {{
        $t('training_tutorial_step_video.sybcpxh')
        }}
      </el-button>
      <el-button type="primary" @click="saveVideo">
        {{
        $t('Common.com_finish')
        }}
      </el-button>
    </div>

    <tutorial-videoNode-drawer
      v-if="drawerVisible"
      :model="drawerModel"
      :productCode="productCode"
      :langCode="langCode"
      :trainingId="trainingId"
      @close="drawerVisible=false"
      @success="getVideoList"
    ></tutorial-videoNode-drawer>

    <product-video-dialog
      v-if="dialogVisible"
      :data="dialogData"
      :model="dialogModel"
      :productCode="productCode"
      :langCode="langCode"
      @close="dialogVisible = false"
    ></product-video-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tutorialVideoNodeDrawer from './tutorial_videoNode_drawer';
import productVideoDialog from './product_video_dialog.vue';

export default {
  components: {
    tutorialVideoNodeDrawer,
    productVideoDialog
  },
  props: {
    productId: [String, Number],
    productCode: [String],
    langCode: [String]
  },
  watch: {
    productCode(val) {

      this.formSearch.productCode = val || '';
      this.getVideoList();
    },

  },
  data() {
    return {
      formSearch: {
        trainingName: '',
        productCode: '',
        langCode: ''
      },
      releaseList: [],
      unPublished: [],

      cloud_common_publish: {},
      // 卡机卡弹窗
      drawerVisible: false,
      drawerModel: {},
      trainingId: '',

      dialogVisible: false,
      dialogData: {},
      dialogModel: {}
    };
  },
  mounted() {
    this.getDictionary('cloud_common_publish', (data) => {
      this.cloud_common_publish = this.$transformDicValue(
        data.cloud_common_publish
      );
    });
    this.formSearch.productCode = this.productCode || '';
    this.formSearch.langCode = this.langCode || 'CN';
    if (this.productCode) {
      this.getVideoList();
    }
  },
  methods: {
    // 添加视频章节
    addVideoNode() {
      this.drawerVisible = true;
      this.trainingId = null;
      this.drawerModel.title = this.$t('training_tutorial_step_video.tian_jia_shi_pin');
      this.drawerModel.type = 'add';
    },
    // 查看视频
    viewVideo: function ({ trainingId, trainingName }) {
      this.dialogVisible = true;
      this.dialogData.trainingId = trainingId;
      this.dialogData.seeType = 'training';
      this.dialogModel.type = 'see';
      this.dialogModel.title = trainingName;
    },
    // 获取视频列表
    getVideoList() {
      this.$getJSON(apis.tmsProductTrainingList, this.formSearch).then((res) => {
        this.releaseList = res.data.filter(i => i.trainingState);
        this.unPublished = res.data.filter(i => !i.trainingState);
      });
    },
    // 编辑视频章节
    editVideo(trainingId) {
      this.drawerVisible = true;
      this.drawerModel.title = this.$t('training_tutorial_step_video.bian_ji_shi_pin');
      this.drawerModel.type = 'edit';
      this.trainingId = trainingId;
    },
    // 删除
    deleteVideoNode: function ({ trainingName, trainingId }) {
      const tips = this.$t('training_tutorial_step_video.qdyscsxjcom', [trainingName]);
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(
            `${apis.tmsProductTrainingDelete}/${trainingId}`
          ).then(() => {
            this.getVideoList();
          });
        })
        .catch(() => {});
    },
    // 撤销发布
    publishStateNo: function ({ trainingName, trainingId }) {
      const tips = this.$t('training_tutorial_step_video.qdycxfbsxjcom', [trainingName]);
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.tmsProductTrainingUpdateState, {
            trainingId,
            trainingState: 0
          }).then(() => {
            this.getVideoList();
          });
        })
        .catch(() => {});
    },
    // 提交发布
    publishState: function ({ trainingName, trainingId }) {
      const tips = this.$t('training_tutorial_step_video.qdyfbsxjcom', [trainingName]);
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.tmsProductTrainingUpdateState, {
            trainingId,
            trainingState: 1
          }).then(() => {
            this.getVideoList();
          });
        })
        .catch(() => {});
    },
    saveVideo: function () {
      this.clearTagByKeep('tutorial_item');
      this.jump('/tutorial', { langCode: this.formSearch.langCode }, true);
    },
    onCancel: function () {
      this.$emit('cancel');
    },
    onBack: function () {
      this.$emit('onBack');
    },

  }
};
</script>

<style lang="scss">
.tutorial-step-video {
  // padding: 24px;
  display: flex;
  flex-direction: column;
  .search-hd {
    padding-top: 16px;
    // height: 46px;
    overflow: hidden;
    padding: 0px;
  }
  .content-box {
    flex: 1;
    .video-release-list,
    .video-releaseno-list {
      margin-top: 24px;
      padding: 25px 15px 16px 15px;
      border: 1px solid #e9ebec;
      position: relative;
      .titel {
        height: 17px;
        font-size: 12px;
        font-weight: bold;
        color: rgba(73, 80, 87, 1);
        line-height: 17px;
        padding: 0 14px;
        background-color: #fff;
        position: absolute;
        left: 24px;
        top: -8.5px;
      }
      ul {
        li {
          height: 70px;
          background: #ffffff;
          padding: 13px 17px 13px 16px;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          .thumbnail {
            width: 70px;
            height: 44px;
            // margin-right: 24px;
            cursor: pointer;
            // overflow: hidden;
            // .icon{
            //   font-size: 44px;
            //   color:#D1D5D9;
            // }
            // .current{
            //   color: #0D9AE0;
            // }
            .video {
              display: block;
              width: 70px;
              height: 44px;
              position: relative;
              .icon {
                text-align: center;
                font-size: 16px;
                position: absolute;
                color: #eeeeeb;
                position: absolute;
                // top: 50%;
                // left: 50%;
                // transform: translate(-50%,-50%);
                top: 0;
                width: 70px;
                height: 44px;
                opacity: 0.3;
                background: #000;
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
            video,
            img {
              display: block;
              // height: 100%;
              width: 70px;
              height: 44px;
            }
          }
          .info {
            padding: 0 16px;
            flex-shrink: 0;
            width: 250px;
            height: 40px;
            overflow: hidden;
            align-self: center;
            p {
              height: 17px;
              font-size: 12px;
              color: rgba(152, 166, 173, 1);
              line-height: 17px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            span {
              height: 25px;
              font-size: 12px;
              font-weight: bold;
              color: rgba(73, 80, 87, 1);
              line-height: 25px;
              display: inline-block;
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .inner {
            flex: 1;
             overflow-x: auto;
            .param {
              display: flex;
              overflow-x: auto;
              .name {
                padding: 0 16px;
                border-right: 1px solid #e9ebec;
                flex-shrink: 0;
                width: 92px;
                height: 40px;
                overflow: hidden;
                align-self: center;
                p {
                  height: 17px;
                  font-size: 12px;
                  color: rgba(152, 166, 173, 1);
                  line-height: 17px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                span {
                  height: 25px;
                  font-size: 12px;

                  // font-weight: bold;
                  color: rgba(73, 80, 87, 1);
                  line-height: 25px;
                  display: inline-block;
                  width: 100%;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                &.status{
                  width: 100px;
                }
                &.charper,&:nth-last-child(2){
                   width: 120px;
                }
                &:last-of-type {
                    width: 160px;
                    border: none !important;
                    span {
                      height: 25px;
                      font-size: 12px;
                      // font-weight: bold;
                      color: rgba(73, 80, 87, 1);
                      line-height: 25px;
                      display: inline-block;
                      width: 170px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    }
                  }
              }

            }
          }
          .card-title {
            height: 21px;
            font-size: 12px;

            font-weight: bold;
            color: rgba(73, 80, 87, 1);
            line-height: 21px;
            .user {
              height: 21px;
              font-size: 12px;
              color: rgba(57, 70, 104, 1);
              line-height: 21px;
            }
            .right {
              float: right;
              height: 17px;
              font-size: 12px;
              color: rgba(13, 154, 224, 1);
              line-height: 17px;
            }
          }
          .card-tips {
            height: 17px;
            font-size: 12px;
            color: rgba(108, 117, 125, 1);
            line-height: 17px;
            .right {
              float: right;
              height: 17px;
              font-size: 12px;
              color: rgba(108, 117, 125, 1);
              line-height: 17px;
            }
          }
          &:hover {
            background: #f9f9fd;
          }
          .more {
            margin-left: auto;
            display: flex;

            .edit,
            .delete,
            .details {
              flex-shrink: 0;
              color: #0d9ae0;
              font-size: 12px;
              color: rgba(13, 154, 224, 1);
              line-height: 22px;
              cursor: pointer;
              padding: 0 20px;
              border-right: 1px solid #e9ebec;
              i {
                color: #0d9ae0;
                font-size: 12px;
                margin: 0;
              }
            }
            .details {
              padding-right: 0;
              border: none;
            }
          }
        }
      }
    }
    .no-data{

      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      padding: 24px;
      text-align: center;
    }

  }
  .tutorial-img {
    padding-bottom: 22px;
  }
}
</style>
